import React, { useState } from "react";
import theme from "../../theme";

// Assets (consider lazy loading these images)
import logoImage from "../../assets/LogoImage.png";
import { useNavigate } from "react-router-dom";
import SC from "./style";
import { Checkbox } from "@mui/material";
import Sidebar from "./Sidebar";
import ContentArea from "./ContentArea";
import ImageModal from "./ImageModal";
// Component
const PlateformAbout = () => {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("about");
  const [selectedImage, setSelectedImage] = useState();

  const handleSectionChange = (section) => {
    console.log(section, "sev");

    setActiveSection(section);
  };

  const handleImageClick = (imageSrc) => {
    setSelectedImage(imageSrc);
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  const handleNavigate = () => {
    navigate("/");
  };

  return (
    <SC.PageWrapper>
      <SC.TopBar>
        <img
          src={logoImage}
          alt="Company Logo"
          loading="lazy"
          onClick={handleNavigate}
          style={{ cursor: "pointer" }}
        />
      </SC.TopBar>

      <SC.MainContent>
        <SC.ImageWrapper>
          <Sidebar
            activeSection={activeSection}
            onSectionChange={handleSectionChange}
          />
        </SC.ImageWrapper>

        <SC.FormWrapper>
          <ContentArea
            activeSection={activeSection}
            onImageClick={handleImageClick}
          />
        </SC.FormWrapper>
      </SC.MainContent>
      {selectedImage && (
        <ImageModal imageSrc={selectedImage} onClose={handleCloseModal} />
      )}
    </SC.PageWrapper>
  );
};

export default PlateformAbout;
